import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {Button, Space} from 'antd';
import type {ButtonColorType} from 'antd/es/button/buttonHelpers';

interface InternalLinkItem {
    label: string;
    path: string;
}

const links: InternalLinkItem[] = [
    { label: 'Inicio', path: '/' },
    { label: 'Términos de Uso', path: '/terms-of-use' },
    { label: 'Políticas de Privacidad', path: '/privacy-policies' }
];

interface ViewProps {
    className?: string;
    isModal?: boolean;
    color?: ButtonColorType;
}

export const ListItemsInfoLinks: React.FunctionComponent<ViewProps> = (props) => {
    const isModal = props.isModal || false;
    const color = props.color || 'primary';

    const navigate = useNavigate();
    const location = useLocation();

    const items = React.useMemo(() => {
        return links
            .filter(link => link.path !== location.pathname)
            .map((link, index) => (
                <Button
                    key={index}
                    onClick={(event) => {
                        event.preventDefault();
                        navigate(link.path);
                    }}
                    className={props.className}
                    variant={ !isModal ? 'link' : 'outlined' }
                    color={ color }
                    block = {isModal}
                >
                    {link.label}
                </Button>
            ));
    }, [location.pathname, props.className, isModal, color, navigate]);

    const direction = React.useMemo( () => isModal ? 'vertical' : 'horizontal', [isModal] );

    return (
        <Space direction={direction} size="middle" style={ isModal ? {width: '100%', marginTop:'20px'} : undefined }>
            {items}
        </Space>
    );
};
